import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { catchError, retry } from 'rxjs/operators';
import { UtilService } from '../services/util.service';
import { APIResponse, City, Country, State } from '../models/models';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()
export class CityService {
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private utilService: UtilService) {
    }

    //public getCitiesDropdown() {
    //    return this.http.get<City[]>(this.baseUrl + 'api/City/GetCitiesDropdown');
    //}

    public getCityByID(cityID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetCityByID/?cityID=' + cityID);
    }

    //public getCitiesById(id: number) {
    //    return this.http.get<City[]>(this.baseUrl + 'api/City/GetCitiesById/?id=' + id);
    //}

    public getCityByCityStateIDZip(cityName: string, stateID: number, zip: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetCityByCityStateIDZip/?cityName=' + cityName + '&stateID=' + stateID + '&zip=' + zip);
    }

    public getCitiesByCityST(cityST: string) {
        return this.http.get<City[]>(this.baseUrl + 'api/City/GetCitiesByCityST/?cityST=' + cityST);
    }

    //public getPickupCitiesByLineID(id: string) {
    //    return this.http.get<City[]>(this.baseUrl + 'api/City/GetPickupCitiesByLineId?id=' + id);
    //}

    public getCitiesStartingWith(firstLetter: string) {
        return this.http.get<City[]>(this.baseUrl + 'api/City/GetCitiesStartingWith/?firstLetter=' + firstLetter);
    }

    public getCountries() {
        //return this.http.get<Country[]>(this.baseUrl + 'api/Country/GetCountries');
        var key: string = "GetCountries";
        var url: string = this.baseUrl + "api/Country/GetCountries";
        return this.utilService.obs(key, url) as Observable<Country[]>;
    }

    public getCountriesWithActivePhone() {
        return this.http.get<APIResponse>(this.baseUrl + "api/Country/GetCountriesWithActivePhone");
    }

    public getStates() {
        //return this.http.get<State[]>(this.baseUrl + 'api/State/GetStates');
        var key: string = "GetStates";
        var url: string = this.baseUrl + "api/State/GetStates";
        return this.utilService.obs(key, url) as Observable<State[]>;
    }

    public getStatesByCountryID(countryID: number) {
        //return this.http.get<APIResponse>(this.baseUrl + 'api/State/GetStatesByCountryID/?countryID=' + countryID);
        var key: string = "GetStatesByCountryID=" + countryID;
        var url: string = this.baseUrl + "api/State/GetStatesByCountryID/?countryID=" + countryID;
        return this.utilService.obs(key, url) as Observable<APIResponse>;
    }

    public getSearchCityStateByCityID(cityID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetSearchCityStateByCityID/?cityID=' + cityID);
    }

    public getSearchCityStateDefaultByCityST(cityST: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetSearchCityStateDefaultByCityST/?cityST=' + cityST);
    }

    public getSearchCityStateByCityST(cityST: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetSearchCityStateByCityST/?cityST=' + cityST);
    }

    public getSearchCityLookupStartsWith(startsWith: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetSearchCityLookupStartsWith/?startsWith=' + startsWith);
    }

    public getRegions() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Region/GetRegions/');
    }

    public getRegionByID(RegionID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Region/GetRegionByID/?RegionID=' + RegionID);
    }

    //public getRegionByCountryID(countryID: number) {
    //    return this.http.get<APIResponse>(this.baseUrl + 'api/Region/GetRegionByCountryID/?countryID=' + countryID);
    //}

    public getMarkets() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Market/GetMarkets/');
    }

    public getMarketByID(marketID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Market/GetMarketByID/?marketID=' + marketID);
    }

    public getMarketByCityID(cityID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Market/GetMarketByCityID/?cityID=' + cityID);
    }

    public getMarketByStateID(stateID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Market/GetMarketByStateID/?stateID=' + stateID);
    }

    public getSearchMarketByID(marketID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Market/GetSearchMarketByID/?marketID=' + marketID);
    }

    public getSearchMarketByCityID(cityID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Market/GetSearchMarketByCityID/?cityID=' + cityID);
    }

    public getSearchMarketByStateID(stateID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Market/GetSearchMarketByStateID/?stateID=' + stateID);
    }

    public getZip3ByZip(zip: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetZip3ByZip/?zip=' + zip);
    }

    public getZip3ByMarketID(marketID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetZip3ByMarketID/?marketID=' + marketID);
    }

    public getZip3ByStateID(stateID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetZip3ByStateID/?stateID=' + stateID);
    }

    public getZip3ByRegionID(regionID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetZip3ByRegionID/?regionID=' + regionID);
    }

    public getZip3ByCountryID(countryID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetZip3ByCountryID/?countryID=' + countryID);
    }

    public getSearchZip3ByZip3(zip3: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetSearchZip3ByZip3/?zip3=' + zip3);
    }

    public getSearchZip3ByMarketID(marketID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetSearchZip3ByMarketID/?marketID=' + marketID);
    }

    public getSearchZip3ByStateID(stateID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetSearchZip3ByStateID/?stateID=' + stateID);
    }

    public getSearchZip3ByRegionID(regionID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetSearchZip3ByRegionID/?regionID=' + regionID);
    }

    public getSearchZip3ByCountryID(countryID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetSearchZip3ByCountryID/?countryID=' + countryID);
    }

    public getSearchZip3ByCountryIDZipMinMax(zip: string, countryID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetSearchZip3ByCountryIDZipMinMax/?zip=' + zip + '&countryID=' + countryID);
    }

    public getSearchZip3ByZip3CountryID(zip3: string, countryID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/GetSearchZip3ByZip3CountryID/?zip3=' + zip3 + '&countryID=' + countryID);
    }

    public saveCity(city: City) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/City/SaveCity/', city, httpOptions);
    }

    public saveCityLatLonTimeZone(cityID: number, latitude: number, longitude: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/City/SaveCityLatLonTimeZone/?cityID=' + cityID + '&latitude=' + latitude + '&longitude=' + longitude);
    }
}
